import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Twitter, Github, Mail } from 'lucide-react';
import Logo from './Logo';
import BrandName from './BrandName';

const Footer = () => {
  const footerLinks = {
    Product: [
      { label: 'Platform', path: '/platform' },
      { label: 'Solutions', path: '/solutions' },
      { label: 'Pricing', path: '/contact' },
      { label: 'Security', path: '/about' },
    ],
    Company: [
      { label: 'About Us', path: '/about' },
      { label: 'Team', path: '/team' },
      { label: 'Careers', path: '/about' },
      { label: 'Contact', path: '/contact' },
    ],
    Resources: [
      { label: 'Blog', path: '/blog' },
      { label: 'Documentation', path: '/blog' },
      { label: 'Case Studies', path: '/solutions' },
      { label: 'Support', path: '/contact' },
    ],
    Legal: [
      { label: 'Privacy Policy', path: '/about' },
      { label: 'Terms of Service', path: '/about' },
      { label: 'Cookie Policy', path: '/about' },
      { label: 'Compliance', path: '/about' },
    ],
  };

  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-12 mb-16">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <Logo height={36} />
            </div>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Blockchain-backed AI for transparent, verifiable ESG intelligence. Building the future of sustainability reporting.
            </p>
            <div className="flex gap-4">
              <SocialLink icon={<Linkedin size={20} />} href="#" />
              <SocialLink icon={<Twitter size={20} />} href="#" />
              <SocialLink icon={<Github size={20} />} href="#" />
              <SocialLink icon={<Mail size={20} />} href="#" />
            </div>
          </div>

          {/* Links Columns */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="text-sm font-bold mb-4" style={{ color: '#1A1A1A' }}>
                {category}
              </h3>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-gray-600 hover:text-gray-900 transition-colors text-sm"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-500">
              © {new Date().getFullYear()} <BrandName />. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm text-gray-500">
              <span>Built with blockchain technology</span>
              <span>•</span>
              <span>Powered by AI</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

const SocialLink = ({ icon, href }) => {
  return (
    <a
      href={href}
      className="p-3 rounded-xl hover:bg-gray-100 transition-colors"
      style={{ color: '#7CB8D6' }}
      target="_blank"
      rel="noopener noreferrer"
    >
      {icon}
    </a>
  );
};

export default Footer;